export enum GradoDifficoltaEnum 
{
    'Difficile' = 1,
    'Difficoltà alta',
    'Facile',
    'Media difficoltà',
    'Non conosciuto'
}